<template>
  <div class="name-wrapper">
    <FriedParagraph v-if="!isTemplate && companyName" class="company-name">
      {{ companyName }}
    </FriedParagraph>
    <FriedH3 class="room-name">
      {{ name }}
    </FriedH3>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    name: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      default: '',
    },
    isTemplate: {
      type: Boolean,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
.name-wrapper {
  width: 100%;
  padding: var(--spacing-100);
  padding-bottom: var(--spacing-50);
}

.company-name,
.room-name {
  color: var(--gray-39);
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.room-name {
  margin-top: var(--spacing-50);
}

.company-name {
  color: var(--gray-49);
  -webkit-line-clamp: 1;
}
</style>
